const fetchData = async (button) => {
  try {
    let productOnPage = button.closest('.collection').querySelector('#product-grid');
    let loadMoreBtn = button;
    let nextPageUrl = productOnPage.dataset.nextUrl;

    loadMoreSpinner.style.display = 'block';
    let response = await fetch(nextPageUrl);

    loadMoreSpinner.style.display = 'none';
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.text();
    let parser = new DOMParser();
    let doc = parser.parseFromString(data, 'text/html');
    let newProductGrid = doc.querySelector('#product-grid');
    let grid__items = newProductGrid.querySelectorAll('li.grid__item');

    grid__items.forEach((gridItem) => {
      productOnPage.append(gridItem);
    });

    let newUrl = newProductGrid.dataset.nextUrl;
    console.log('newUrl ', newUrl);

    productOnPage.dataset.nextUrl = newUrl;

    if (newUrl) {
      loadMoreBtn.style.display = 'block';
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

const loadmore = async (button) => {
  button.style.display = 'none';
  fetchData(button);
};
